import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildStoneArch: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);

    brush.box(0, 1, 0, 3, 0, 0, BLOCK.Stone);
    brush.box(5, 6, 0, 3, 0, 0, BLOCK.Stone);
    brush.lineX(0, 6, 4, 0, BLOCK.Stone);
    brush.lineX(1, 5, 5, 0, BLOCK.Stone);
    brush.block(2, 0, 1, BLOCK.Rock);
    brush.block(4, 0, 1, BLOCK.Rock);
};
